import moment from "../../../../../../plugins/moment";
import * as BOOKING_ACTIONS from "../../../../../../store/booking/action-types";
import {
  GET_BOOKING_DISCOUNT_CODE_IS_APPLICABLE,
  GET_BOOKING_DISCOUNT_CODE,
  GET_TERMS,
  GET_DOCUMENT_NEED
} from "../../../../../../store/booking/getter-types";
import {
  BOOKING_UPDATE,
  SET_BOOKING_DISCOUNT_CODE,
  SET_BOOKING_NEWSLETTER,
  SET_TERMS
} from "../../../../../../store/booking/mutation-types";
import * as STEPPER_ACTIONS from "../../../../../../store/stepper/action-types";
import stepMixin from "../../../../../../utils/mixins/stepMixin.js";
import axios from "axios";
import { SET_PAYMENT_METHOD } from "../../../../../../store/mutation-types";
import { NIGHTS_SET_PACK } from "../../../../../../store/nights/mutation-types";
import { GET_PAYMENT_METHOD } from "../../../../../../store/getter-types";
import prepareChoice from "../../../../../../utils/prepareReservation";
import passengerLabel from "../../../../../../utils/mixins/passengerLabel";
import Axios from "axios";
import { mapActions } from "vuex";
import { getDiffFromNowInYears } from "../../../../../../plugins/moment";

export default {
  mixins: [stepMixin, passengerLabel],
  data: () => ({
    // TODO; meter toda los otros forms aca y agregar spetial needs en adults
    form: {
      valid: false,
      passengers: [],
      discount: {
        value: null,
        isLoading: false
      },
      comments: '',
      codeAttempted: false,
    },
    showPaypal: false,
    showOverlay: false
  }),
  computed: {
    discountCode() {
      return this.$store.getters[GET_BOOKING_DISCOUNT_CODE];
    },
    discountIsApplicable() {
      return this.$store.getters[GET_BOOKING_DISCOUNT_CODE_IS_APPLICABLE];
    },
    paymentMethod() {
      return this.$store.getters[GET_PAYMENT_METHOD];
    },
    terms() {
      return this.$store.getters[GET_TERMS].terms;
    },
    documentNeeded(){
      const seat_selected = this.$store.state.booking.extras.available.find((extra) => extra.id == 2 && extra.selected);

      return seat_selected ? !seat_selected.selected : this.$store.getters[GET_DOCUMENT_NEED];
    }
  },
  methods: {
    setPackFlightToFalse() {
      this.$store.commit(NIGHTS_SET_PACK, false);
    },
    showPaypalToFalse() {
      this.showPaypal = false;
    },
    showOverlayToFalse() {
      this.showOverlay = false;
    },
    scrollToBottom() {
      if (window.matchMedia("(min-width: 1280px)").matches) {
        window.scrollTo(0, 9999);
      }
    },
    freebooking() {
      this.$store.dispatch(STEPPER_ACTIONS.SET_STEPPER_LOADING, true);
      this.setTermsError();


      if (this.validPassengers() && this.checkDatesValid() && !this.terms.error) {
        this.showOverlay = true;
        this.$store
          .dispatch(
            BOOKING_ACTIONS.SET_BOOKING_PASSENGERS,
            this.form.passengers
          )
          .then(() => {
            return axios
              .get("/api/freereservation", {
                params: {
                  reservation: prepareChoice('default')
                }
              })
              .then(res => {
                return this.$router.push("/viaje/" + res.data.code + "/confirmacion");
              })
              .catch(err => {
                console.log(err);
                this.$toastr.e(
                  window.i18n.t('toast.error_4')
                );
              });
          })
          .catch(err => {
            console.log(err);
            this.$toastr.e(
              window.i18n.t('toast.error_4')
            );
          })
          .finally(() => {
            this.showOverlay = false;
            this.$store.dispatch(STEPPER_ACTIONS.SET_STEPPER_LOADING, false);
          });
      } else {
        this.showOverlay = false;
        this.$store.dispatch(STEPPER_ACTIONS.SET_STEPPER_LOADING, false);
      }
    },
    chooseSubmitMethod() {
      if (this.totalPrice > 0) {
        this.submitStep();
      } else {
        this.freebooking();
      }
    },
    submitStep() {
      this.$store.dispatch(STEPPER_ACTIONS.SET_STEPPER_LOADING, true);
      this.setTermsError();

      if (this.validPassengers() && this.checkDatesValid() && !this.terms.error) {
        this.$store
          .dispatch(
            BOOKING_ACTIONS.SET_BOOKING_PASSENGERS,
            this.form.passengers
          )
          .then(() => {
            if (this.paymentMethod == "paypal") {
              this.showPaypal = true;
              this.showOverlay = true;
              const paypalContainer = document.getElementById(
                "submitContainer"
              );

              window.scrollTo({
                top: paypalContainer.offsetTop,
                left: 0,
                behavior: "smooth"
              });
            } else this.retrievePaymentParameters();
          })
          .catch(error => {
            this.$store.dispatch(STEPPER_ACTIONS.SET_STEPPER_LOADING, false);
            this.$toastr.e(
              window.i18n.t('toast.error_2')
            );
          });
      } else {
        this.$store.dispatch(STEPPER_ACTIONS.SET_STEPPER_LOADING, false);
      }
    },
    retrievePaymentParameters() {
      this.$refs.paymentMethods.$refs.redsysComponent.retrievePaymentParameters();
    },
    submitStripeForm(){
      const stripe_button = document.getElementById("submit-stripe");
      console.log(stripe_button);

      stripe_button.click();
    },
    setTermsError() {
      this.$store.commit(SET_TERMS, {
        ...this.$store.getters[GET_TERMS],
        terms: {
          error: !this.terms.value,
          value: this.terms.value
        }
      });
    },
    checkDatesValid(){
      var passengerEvaluating;

      const valid = this.form.passengers.every(passenger => {
        const diffInYears = getDiffFromNowInYears(passenger.date_of_birth)
        passengerEvaluating = {...passenger}
        switch (passenger.type) {
          case 'adult':
            return diffInYears >= 16
          case 'child':
            return diffInYears > 2 && diffInYears < 16
          case 'baby':
            return diffInYears < 2;
          default:
            return true;
        }
      });

      if(!valid) this.$toastr.e(this.$t('toast.error_date', {name: passengerEvaluating.name}))

      return valid
    },
    validPassengers() {
      this.form.passengers = [];
      for (let i = 1; i <= this.travellersTotal; i++) {
        const ref = "formAdult" + i;
        if (this.$refs[ref][0]) {
          this.form.valid = this.$refs[ref][0].validate();

          if (this.form.valid) {
            let form = JSON.parse(JSON.stringify(this.$refs[ref][0].form));
            this.form.passengers.push({
              name: form.firstName.value,
              lastName: form.lastName.value,
              email: form.email.value,
              type: this.travellersMerged[i - 1],
              card_id_type: form.idCard.type.value,
              card_id: form.idCard.number.value,
              date_of_birth: new Date(
                form.birthday.year.value,
                form.birthday.month.value - 1,
                form.birthday.day.value,
                12,
                0,
                0
              ),
              gender: form.gender.value,
              nationality: form.nationality.value,
              phone: form.phone.number.value,
              phone_prefix: form.phone.countryCode.value,
              expiration_date: new Date(
                form.expiration_date.year.value,
                form.expiration_date.month.value - 1,
                form.expiration_date.day.value,
                12,
                0,
                0
              ),
            });
          } else {
            this.$toastr.e(this.$t('toast.error_5'));
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: "smooth"
            });
            return false;
          }
        }
      }
      return true;
    },
    validateCode: window._.debounce(function() {
      const code = this.form.discount.value;
      const path = code.startsWith("GIFT-")
        ? "/api/gifts/"
        : "/coupon?discount=";

      this.form.discount.isLoading = true;
      this.codeAttempted = true;

      axios
        .get(path + code)
        .then(({ data }) => {
          this.$store.commit(SET_BOOKING_DISCOUNT_CODE, data);
        })
        .catch(() => {
          this.$store.commit(SET_BOOKING_DISCOUNT_CODE, "");
        })
        .finally(() => (this.form.discount.isLoading = false));
    }, 300),
  },
  watch: {
    form: {
      deep: true,
      handler(form) {
        this.$store.commit(BOOKING_UPDATE, { comments: form.comments });
      }
    }
  },
  created(){
    this.setPackFlightToFalse();
  }
};
